<template>
  <div style="width:100%;">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        			 <screenButton></screenButton>
      </div>
    </div>
    <div style="padding-top: 50px;"  class="mater">
      <b-table striped small sticky-header sticky-header="calc(100vh - 50px)" head-variant="light" responsive bordered
               :items="items" :fields="fields" foot-clone>
        <template v-slot:head()="scope">
          <div class="text-nowrap" :style="{textAlign:'center'}">
            {{ scope.label }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          {{ data.index + 1 }}
        </template>
        <template v-slot:cell(materialData)="data" style="'left':' 80px';">
          {{ data.item.materialName }}/{{ data.item.materialModel?data.item.materialModel:'-' }}/{{ data.item.materialUnit }}
        </template>
        <template v-slot:table-colgroup="scope">
          <col
              v-for="field in scope.fields"
              :key="field.key"
              :style="{ width: field.key === 'materialData' ? '140px' : field.key === 'index' ?'30px': field.key === 'costPrice' ?'120px':'100px',left: field.key === 'materialData' ? '120px' : '80px'}"
          />
        </template>
        <template v-slot:foot()="scope">
          <div class="text-nowrap" :style="{textAlign:'center'}">-</div>
        </template>
        <template v-slot:foot(index)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">合计</div>
        </template>
        <template v-slot:foot(inventoryNum)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'inventoryNum')}}</div>
        </template>
        <template v-slot:foot(hcNum)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'hcNum')}}</div>
        </template>
        <template v-slot:foot(hcLeftNum)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'hcLeftNum')}}</div>
        </template>
        <template v-slot:foot(outboundNum)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'outboundNum')}}</div>
        </template>
        <template v-slot:cell(costPrice)="data">
          {{ data.item.costPrice !== null && data.item.costPrice !== undefined ? Number(data.item.costPrice).toFixed(4) : '' }}
        </template>
      </b-table>
      <!-- <div>{{items}}</div> -->
    </div>
  </div>
</template>

<script>
import {BTable} from 'bootstrap-vue'
import {Decimal} from "decimal.js";


export default {
  data() {
    return {
      fields: [
        {key: 'index', stickyColumn: true, label: '序号'},
        {key: 'materialData', stickyColumn: true, label: ' 专业名称/规格/单位'},
        {key: 'materialCommonName', label: '常用名称'},
        {key: 'brandName', label: '品牌'},
      ],
      items: [],
      dataList: [],
      businessId: '',
      wareNumerLabel: '',
      searchForm: {
        deratedId: ''
      },
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 5,
        orders: []
      },
      layoutHeight: '0px',
      outboundNumTitle: null,
      time: 0
    }
  },
  mounted() {
  },
  created() {
    this.$nextTick(() => {
      this.layoutHeight = document.documentElement.clientHeight - 50 + 'px';
      let query = this.$route.query;
      this.items = query.data.exWarehouseSubs
      this.joint(["materialName", "materialModel", "materialUnit"])
      if (query.data.mode != '2') {
        this.fields.push({key: 'inventoryNum', label: '当前库存量(不含在途)'})
      } else {
        this.fields.push({key: 'hcNum', label: '已红冲数量'}, {key: 'hcLeftNum', label: '剩余未红冲数量'})
      }
      if (query.data.mode == '1') {
        this.outboundNumTitle = '出库数量';
      } else if (query.data.mode == '2') {
        this.outboundNumTitle = '红冲数量';
      } else if (query.data.mode == '3') {
        this.outboundNumTitle = '盘亏数量';
      }else if (query.data.mode == '4') {
        this.outboundNumTitle = '销售数量';
      }else if (query.data.mode == '6') {
        this.outboundNumTitle = '红冲销售数量';
      }
      this.fields.push({key: 'outboundNum', label: this.outboundNumTitle})
      // 包装物料单价：存在任一单价>0时显示该列（移动端只读展示）
      if (this.items.some(i => i.costPrice && Number(i.costPrice) > 0)) {
        this.fields.push({key: 'costPrice', label: '包装物料单价（元）'})
      }
      this.fields.push({key: 'remarks', label: '备注'})
    });
  },
  methods: {
    init() {
    },
    joint(data) {
      this.items.forEach(i => {
        i.materialData = {}
        data.forEach(key => {
          i.materialData[key] = i[key]
        })
      })
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(2, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>

